import util from '../util'

let controller = 'ParceiroIp'
export default Object.assign({}, util.GetCrud(controller, null), {
  Patch: function (dto,id) {
    return util.Axios.Patch(controller + "/" + id, dto)
  }
})
